import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import FooterBar from '../components/FooterBar';
import Loader from '../components/Loader';
import Movie from '../components/Movie';
import SearchBar from '../components/SearchBar';
import Toast from '../components/Toast';
import { useGlobalContext } from '../Context';
import { api } from '../components/api';
import { GlobalStyle } from '../GlobalStyles';

const SearchResultsPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [searchResults, setSearchResults] = useState('');
  const [pageCount, setPageCount] = useState('');
  const { query } = useParams();
  const { searchForMovie, showToast } = useGlobalContext();

  const handleLoadMore = (e) => {
    e.preventDefault();
    setPageCount((prev) => parseInt(prev + 1));
  };

  useEffect(() => {
    setIsLoading(true);

    const querySearch = async () => {
      try {
        const resp = await fetch(
          `${api.url}${api.search}?api_key=${api.apiKey}&query=${query}&page=${pageCount}`
        );

        const data = await resp.json();
        const full = data.results.filter((movie) => {
          if (movie.poster_path) {
            return movie;
          }
          return null;
        });

        setSearchResults(() => {
          return {
            ...data,
            results: [...full],
          };
        });
        searchForMovie(full);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };

    querySearch();
  }, [query, pageCount]);

  if (isLoading || searchResults.length === 0) {
    return (
      <div className='app-wrapper'>
        <Navbar />
        <SearchBar />
        <Loader />
        <FooterBar />
        <GlobalStyle />
      </div>
    );
  }

  return (
    <div className='app-wrapper'>
      <Navbar />
      <SearchBar />
      <h4 style={{ textAlign: 'center', margin: '4rem auto 0 auto' }}>
        Your search for: '{query}' returned: {searchResults.results.length}{' '}
        results
      </h4>
      <div className='block-wrapper'>
        {searchResults.results.map((movie) => {
          return <Movie key={movie.id} movie={movie} />;
        })}
      </div>
      {searchResults.total_pages > 1 &&
        pageCount <= searchResults.total_pages && (
          <button onClick={(e) => handleLoadMore(e)}>Load more</button>
        )}
      <FooterBar />
      {showToast.isShowing && (
        <Toast heading={showToast.heading} message={showToast.msg} />
      )}
      <GlobalStyle />
    </div>
  );
};

export default SearchResultsPage;
